const roundThreeDigits = (number) => Math.round((number % 1) * 1000) / 1000;
export default roundThreeDigits;
